import { IFacultyQuickLinks } from "../../../../../models/dashboard/facultyDashboard";
import { connect, useDispatch } from "react-redux";
import { useEffect } from "react";
import { pageBlockId } from "../../../../../constants/pageBlocks";
import { setQuickLinksWidget } from "../../../../../store/slices/master/widgetSlice";
import { getWidgets } from "../../../../../action/masters/widgetActionCreator";

const FacultyAllQuickLinks = (props: IFacultyQuickLinks) => {
  const { getQuickLinks, quickLinks } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    getQuickLinks(pageBlockId.facultyQuickLinks);
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setQuickLinksWidget([]));
    };
  }, []);

  return (
    <div className="widgets">
      <div className="title">
        <h2>All Quick Links</h2>
      </div>
      <div className="card-wrap">
        <div className="row">
          {quickLinks
            ?.filter((link) => link.displayOrNot)
            .map((link) => (
              <div className="col-md-12 mb-3" key={link.id}>
                <div className="resourcecard icon-visibility">
                  <a href={link.url} target="_blank" className="h-100">
                    <div className="img"><img src={link.image} alt="" /></div>
                    <div className="dtls">
                      <h3 className="para-hide-1">{link.name}</h3>
                      <p className="para-hide-2">{link.description}</p>
                    </div>
                    <span>
                      <img src="/assets/images/icon/arrow-right.svg" alt="" />
                    </span>
                  </a>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  getQuickLinks: (pageBlockId: number, noOfItems: undefined) =>
    getWidgets(undefined, pageBlockId, undefined),
};

function mapStateToProps(state: any) {
  return {
    quickLinks: state.widget.quickLinkWidget,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FacultyAllQuickLinks);
